<template>
   <div class="general-settings">
      <NxtSection
         :title="$t('general_tab.user-settings')"
         :class="'mb-3'"
      >
         <div class="row gap-3 mt-3">
            <NxtSelectBridge
               :model-value="userInfo?.language_id"
               :class="'col-4'"
               :label="$t('languages', 1)"
               :has-clear-option="false"
               :search-type="'none'"
               :name="'language_id'"
               :emit-object="true"
               :options="possibleLanguages"
               @update:model-value="changeConsultantLanguage"
            />
         </div>
      </NxtSection>
   </div>
</template>

<script setup>
import store from '@/core/store';
import { NxtSection, NxtSelectBridge } from '@nxtpeople/nxt-styles';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

//#region Globals
const { t, locale } = useI18n();
//#endregion

const possibleLanguages = computed(() => {
   return languages.value?.filter((l) => ['nl', 'en', 'fr'].includes(l.code.toLowerCase()));
});

const userInfo = computed(() => {
   return store.state.userInfo.userInfo;
});

const languages = computed(() => {
   return store.state.journeysStore.languages;
});

const changeConsultantLanguage = async (e) => {
   const languageCode = languages.value.find((l) => l.id == e.id).code.toLowerCase();
   locale.value = languageCode;
   await store.dispatch('userInfo/patchUser', { op: 'replace', path: 'language_id', value: e.id });
};
</script>
